import { Component, OnInit, Input } from '@angular/core';

import { LayoutInterface } from './location.interface';

import { environment } from '../../../../../environments/environment';
import { CountryShared } from '../../models/interface/country.interface';
import { UserDataService } from '../../sharedServices/user-data.service';
import { MuUserService } from '../../sharedProtos/user/mu-user.service';
import { MuLayoutService } from '../../sharedProtos/layout/mu-layout.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.sass'],
})
export class LocationComponent implements OnInit {
  data: LayoutInterface;
  country: string;
  display = false;
  enviromentCountries: CountryShared[];
  @Input() ingressCountrySel: string;

  constructor(
    private serviceLayout: MuLayoutService,
    private muUserService: MuUserService,
    private userDataService: UserDataService,
    private router: Router
  ) {
    this.enviromentCountries = environment.countries;
  }

  ngOnInit() {
    if (localStorage.hasOwnProperty('location')) {
      this.country = localStorage.getItem('location');
      this.serviceLayout.changeCountryValue(this.country);
      this.display = false;
    } else if (this.router.url !== '/page/login' && this.router.url !== '/') {
      this.serviceLayout.changeCountryValue(this.enviromentCountries[0].geoName);
      this.display = false;
    }
  }

  async setCountry(country): Promise<void> {
    localStorage.setItem('location', country.geoName);
    this.serviceLayout.changeCountryValue(country.geoName);
    this.display = false;
    const userData = await this.userDataService.getUserDataAsPromise();
    this.muUserService.updateUserData(parseInt(userData.id, 10), { countryId: country.id });
  }

  setLocationbyCOrdinates() {
    navigator.geolocation.getCurrentPosition(
      position => {
        this.data.latitude = position.coords.latitude;
        this.data.longitude = position.coords.longitude;
      },
      err => {
        this.data.latitude = 4.7195437;
        this.data.longitude = -74.0463781;
      }
    );
  }
}
